import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import './LoadError.css';

/**
 * A failed read, said as one: what could not be loaded, and a Retry. Place it
 * at the top of the area it affects, in place of that area's empty state.
 */
function LoadError({ what, message, onRetry, className = 'mb-3' }) {
    return (
        <Alert variant="danger" role="alert" className={className}>
            <p className="mb-2 fw-semibold">
                {message || `We could not load ${what}.`}
            </p>
            <p className="mb-2">
                This is a problem loading, not missing data. Nothing was lost.
            </p>
            {onRetry && (
                <Button
                    variant="danger"
                    size="sm"
                    className="load-error-retry"
                    onClick={onRetry}
                >
                    Retry
                </Button>
            )}
        </Alert>
    );
}

export default LoadError;
